// mds-dojo — dijit/MenuItem — FAITHFUL port of references/dijit/MenuItem.js.
// A line item in a Menu widget. declare from the faithful runtime; template imported
// via ?raw. dojo-bidi (_NoBidi declaredClass suffix + trailing bidi re-declare) and
// the has("ie")==8 focus workaround dropped (evergreen). kernel.deprecated guarded.
import declare from '../dojo/_base/declare-runtime'; // declare
import dom from '../dojo/dom'; // dom.setSelectable
import domAttr from '../dojo/dom-attr'; // domAttr.set
import domClass from '../dojo/dom-class'; // domClass.toggle
import kernel from '../dojo/_base/kernel'; // kernel.deprecated
import _Widget from './_Widget';
import _TemplatedMixin from './_TemplatedMixin';
import _Contained from './_Contained';
import _CssStateMixin from './_CssStateMixin';
import template from './templates/MenuItem.html?raw';

export default declare('dijit.MenuItem',
  [_Widget, _TemplatedMixin, _Contained, _CssStateMixin], {
  // summary:
  //		A line item in a Menu Widget

  // Make 3 columns: icon, label, and expand arrow (BiDi-dependent) indicating sub-menu
  templateString: template,

  baseClass: 'dijitMenuItem',

  // label: String
  //		Menu text as HTML
  label: '',
  _setLabelAttr: function (val: any) {
    this._set('label', val);
    var shortcutKey = '';
    var text;
    var ndx = val.search(/{\S}/);
    if (ndx >= 0) {
      shortcutKey = val.charAt(ndx + 1);
      var prefix = val.substr(0, ndx);
      var suffix = val.substr(ndx + 3);
      text = prefix + shortcutKey + suffix;
      val = prefix + '<span class="dijitMenuItemShortcutKey">' + shortcutKey + '</span>' + suffix;
    } else {
      text = val;
    }
    this.domNode.setAttribute('aria-label', text + (this.accelKey ? ' ' + this.accelKey : ''));
    this.containerNode.innerHTML = val;
    this._set('shortcutKey', shortcutKey);
  },

  // iconClass: String
  //		Class to apply to DOMNode to make it display an icon.
  iconClass: 'dijitNoIcon',
  _setIconClassAttr: { node: 'iconNode', type: 'class' },

  // accelKey: String
  //		Text for the accelerator (shortcut) key combination.
  accelKey: '',

  // disabled: Boolean
  //		If true, the menu item is disabled.
  disabled: false,

  _fillContent: function (/*DomNode*/ source: any) {
    // If button label is specified as srcNodeRef.innerHTML rather than this.params.label, handle it here.
    if (source && !('label' in this.params)) {
      this._set('label', source.innerHTML);
    }
  },

  buildRendering: function () {
    this.inherited(arguments);
    var label = this.id + '_text';
    domAttr.set(this.containerNode, 'id', label); // only needed for backward compat
    if (this.accelKeyNode) {
      domAttr.set(this.accelKeyNode, 'id', this.id + '_accel'); // only needed for backward compat
    }
    dom.setSelectable(this.domNode, false);
  },

  onClick: function (/*Event*/) {
    // User defined function to handle clicks
  },

  focus: function () {
    // Focus on this MenuItem
    try {
      this.focusNode.focus();
    } catch (e) {
      // this throws on IE (at least) in some scenarios
    }
  },

  _setSelected: function (selected: any) {
    // Indicate that this node is the currently selected one
    domClass.toggle(this.domNode, 'dijitMenuItemSelected', selected);
  },

  setLabel: function (/*String*/ content: any) {
    // Deprecated.   Use set('label', ...) instead.
    (kernel as any).deprecated && (kernel as any).deprecated('dijit.MenuItem.setLabel() is deprecated.  Use set(\'label\', ...) instead.', '', '2.0');
    this.set('label', content);
  },

  setDisabled: function (/*Boolean*/ disabled: any) {
    // Deprecated.   Use set('disabled', bool) instead.
    (kernel as any).deprecated && (kernel as any).deprecated('dijit.Menu.setDisabled() is deprecated.  Use set(\'disabled\', bool) instead.', '', '2.0');
    this.set('disabled', disabled);
  },

  _setDisabledAttr: function (/*Boolean*/ value: any) {
    // Hook for attr('disabled', ...) to work.  Enable or disable this menu item.
    this.focusNode.setAttribute('aria-disabled', value ? 'true' : 'false');
    this._set('disabled', value);
  },

  _setAccelKeyAttr: function (/*String*/ value: any) {
    // Hook for attr('accelKey', ...) to work.  Set accelKey on this menu item.
    if (this.accelKeyNode) {
      this.accelKeyNode.style.display = value ? '' : 'none';
      this.accelKeyNode.innerHTML = value;
      //have to use colSpan to make it work in IE
      domAttr.set(this.containerNode, 'colSpan', value ? '1' : '2');
    }
    this._set('accelKey', value);
  },
});
